import { Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface INoArchievedDataViewProps {
  addExtraBottomMargin?: boolean;
}

const NoArchievedDataView = ({ addExtraBottomMargin }: INoArchievedDataViewProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const height = addExtraBottomMargin ? '90%' : '100%';

  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height={height}
      bgcolor="#fff"
      boxShadow={theme.borderStyles.cardBorders}
    >
      <img src="/assets/icons/clipboard-remove.svg" alt="img" />
      <Typography variant="title2Bold" color="primary">
        {t('clientPage.noArchivedClients')}
      </Typography>
    </Grid>
  );
};

export default NoArchievedDataView;
